import React from "react";
import { partitionManufacturers } from "@/data/site";

function ManufacturerSet({ duplicate = false }: { duplicate?: boolean }) {
  return (
    <div className="accessory-brand-marquee__set" aria-hidden={duplicate || undefined}>
      {partitionManufacturers.map((manufacturer) => (
        <div className="accessory-brand-marquee__item" key={`${duplicate ? "duplicate-" : ""}${manufacturer.id}`}>
          <img
            src={manufacturer.logo}
            width={manufacturer.logoWidth}
            height={manufacturer.logoHeight}
            alt={duplicate ? "" : manufacturer.logoAlt}
            loading="lazy"
          />
          <span>{manufacturer.scope}</span>
        </div>
      ))}
    </div>
  );
}

export function PartitionManufacturerShowcase() {
  return (
    <section className="partition-manufacturer-banner" aria-labelledby="partition-manufacturers-title">
      <div className="partition-manufacturer-banner__heading">
        <span className="kicker">Partition manufacturers we carry</span>
        <h3 id="partition-manufacturers-title">Specified brands. One source.</h3>
      </div>
      <div className="accessory-brand-marquee partition-manufacturer-banner__marquee" role="region" aria-label="Commercial bathroom partition manufacturers" tabIndex={0}>
        <div className="accessory-brand-marquee__track">
          <ManufacturerSet />
          <ManufacturerSet duplicate />
        </div>
      </div>
      <p className="accessory-brand-band__motion-note">Hover or focus the brand strip to pause it. Manufacturer availability is confirmed for each quote.</p>
    </section>
  );
}
